import Swiper, { Navigation, Autoplay, Pagination } from 'swiper';
Swiper.use([Navigation, Autoplay, Pagination]);

function CenteredCarousel() {
	$('.js-centered-carousel').each(function(index) {
    let $this = $(this);
    let carouselIndex = index;
    $this.addClass('centered-carousel-' + index);
    let carouselList = [];
    let $counterContainer = $('.centered-carousel__counter');

		let cCarousel = new Swiper('.centered-carousel-' + index, {
			slidesPerView: 1,
			speed: 400,
			spaceBetween: 0,
			centeredSlides: true,
			loop: true,
			simulateTouch: true,
      		breakpoints: {
			575: {
			  spaceBetween: 20,
			  slidesPerView: 1.25,
			},
			767: {
				slidesPerView: 1.5,
			},
			991: {
				slidesPerView: 1.75,
			},
			1199: {
				slidesPerView: 1.9,
				spaceBetween: 30
			}
		  },

		  navigation: $this.data("navigationtype") === "arrows" || $this.data("navigationtype") === undefined ? {
			nextEl: ".centered-carousel__navigation .swiper-button-next",
					prevEl: ".centered-carousel__navigation .swiper-button-prev"
		  } : false,

		  pagination: $this.data("navigationtype") === "dots" ? {
			el: ".centered-carousel__pagination",
			type: "bullets",
			clickable: true
		  }: false,

		  autoplay: $this.data("autoplayspeed") != undefined ? {
			delay: parseInt($this.data("autoplayspeed"))
		  } : false,

		  on: {
			init: function (swiper:any) {
				let $slideLength = $(`.centered-carousel-${carouselIndex} .swiper-slide:not(.swiper-slide-duplicate)`).length;
				$counterContainer.text(`${swiper.realIndex + 1}/${$slideLength}`);

			  if ($this.data("navigationtype") === "arrows" || $this.data("navigationtype") === undefined) {
				$('.centered-carousel__pagination').remove();
			  }

			  if ($this.data("navigationtype") === "dots") {
				$('.centered-carousel__navigation').remove();
			  }
			},
			slideChange: function (swiper:any) {
				let $slideLength = $(`.centered-carousel-${carouselIndex} .swiper-slide:not(.swiper-slide-duplicate)`).length;
				$counterContainer.text(`${swiper.realIndex + 1}/${$slideLength}`);
			}
		  }
    });

    carouselList.push(cCarousel);
    cCarousel.init();
	});
}

export function init() {
	CenteredCarousel();
}
